// Fonte: UManutContas.pas, linhas 3750-3817 — Busca de Cadastro Único ao inserir Fornecedor
// Fonte: UBuscaCadUnico.pas — modal de pesquisa
import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button, Table, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { listarCadUnicoFornecedores, cadastrarCadUnicoNoGE } from '~/Services/Service';
import { format } from '~/Utils/Helpers';

var ModalCadastroUnico = function(_ref) {
  var show = _ref.show;
  var ge = _ref.ge;
  var onHide = _ref.onHide;
  var onContaCriada = _ref.onContaCriada;

  var [busca, setBusca] = useState('');
  var [resultados, setResultados] = useState([]);
  var [loading, setLoading] = useState(false);
  var [criando, setCriando] = useState(false);
  var [buscaExecutada, setBuscaExecutada] = useState(false);

  // Limpar estado quando modal abre
  useEffect(function() {
    if (show) {
      setBusca('');
      setResultados([]);
      setBuscaExecutada(false);
    }
  }, [show]);

  var executarBusca = useCallback(function() {
    if (!busca || busca.trim().length < 2) {
      toast.warning('Digite pelo menos 2 caracteres para buscar');
      return;
    }
    setLoading(true);
    setBuscaExecutada(true);
    listarCadUnicoFornecedores(busca.trim())
      .then(function(resp) {
        var lista = Array.isArray(resp) ? resp : [];
        setResultados(lista);
        if (lista.length === 0) {
          toast.info('Nenhum cadastro único encontrado');
        }
      })
      .catch(function() {
        toast.error('Erro ao buscar cadastro único');
      })
      .finally(function() { setLoading(false); });
  }, [busca]);

  var handleKeyDown = function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      executarBusca();
    }
  };

  var handleSelecionar = function(item) {
    if (!ge) {
      toast.error('Selecione o Grupo de Empresa antes');
      return;
    }
    setCriando(true);
    cadastrarCadUnicoNoGE(item.codigo, ge)
      .then(function(resp) {
        var codigoConta = resp && resp.codigo_conta ? resp.codigo_conta : null;
        if (codigoConta) {
          toast.success('Fornecedor criado com sucesso! Código: ' + codigoConta);
          if (onContaCriada) onContaCriada(ge, codigoConta);
        } else {
          toast.error('Resposta inesperada do servidor');
        }
      })
      .catch(function(err) {
        var msg = (err && typeof err === 'object' && err.mensagem)
          ? err.mensagem
          : 'Erro ao criar fornecedor a partir do cadastro único';
        toast.error(msg);
      })
      .finally(function() { setCriando(false); });
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static" keyboard={false}>
      <Modal.Header closeButton className="contas-modal-header">
        <Modal.Title>Cadastro Único — Fornecedor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">
          Pesquise o fornecedor no Cadastro Único pelo nome, CNPJ ou código.
          Ao selecionar, a conta será criada automaticamente no GE {ge || '?'}.
        </p>

        <div className="d-flex mb-3">
          <Form.Control
            type="text"
            size="sm"
            placeholder="Nome, CNPJ ou código..."
            value={busca}
            onChange={function(e) { setBusca(e.target.value); }}
            onKeyDown={handleKeyDown}
            disabled={criando}
            autoFocus
          />
          <Button
            variant="primary"
            size="sm"
            className="ml-2"
            onClick={executarBusca}
            disabled={loading || criando}
            style={{ whiteSpace: 'nowrap' }}
          >
            {loading ? <Spinner animation="border" size="sm" /> : 'Buscar'}
          </Button>
        </div>

        {criando && (
          <div className="text-center py-3">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted small">Criando fornecedor...</p>
          </div>
        )}

        {!criando && buscaExecutada && (
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            <Table striped bordered hover size="sm" className="mb-0">
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Cód.</th>
                  <th>Apelido</th>
                  <th>Razão Social</th>
                  <th style={{ width: 150 }}>CNPJ/CPF</th>
                  <th style={{ width: 100 }}>Grupo</th>
                  <th style={{ width: 80 }}>Contas</th>
                  <th style={{ width: 80 }}></th>
                </tr>
              </thead>
              <tbody>
                {resultados.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-muted">
                      Nenhum registro encontrado
                    </td>
                  </tr>
                ) : resultados.map(function(item) {
                  return (
                    <tr key={item.codigo}>
                      <td>{item.codigo}</td>
                      <td>{item.apelido}</td>
                      <td>{item.razao_social}</td>
                      <td>{item.cpf ? format.cpf(String(item.cpf)) : ''}</td>
                      <td>{item.grupo}</td>
                      <td className="text-center">{item.total_contas || 0}</td>
                      <td className="text-center">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={function() { handleSelecionar(item); }}
                          disabled={criando}
                        >
                          Selecionar
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide} disabled={criando}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCadastroUnico;
